import { ExportOutlined, PlusOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  EXPORT_TYPES,
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import GiftCardTable from '../components/GiftCardTable';
import { REQUEST_GIFT_CARD_EXPORT } from '../graphql/Mutations';

const GiftCard = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const history = useHistory();
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState({});
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestGiftCardExport] = useMutation(REQUEST_GIFT_CARD_EXPORT, {
    onError: () => {},
  });

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestGiftCardExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.GIFT_CARD,
        },
        filter: {
          search: exportFilter?.search,
          isArchived: exportFilter?.isArchived,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          expiredAtDate: {
            from: exportFilter?.expiredAt?.from?.$d,
            to: exportFilter?.expiredAt?.to?.$d,
          },
          startedAtDate: {
            from: exportFilter?.startedAt?.from?.$d,
            to: exportFilter?.startedAt?.to?.$d,
          },
          ...(exportFilter?.billingCycle?.length > 0 && {
            planTypes: exportFilter.billingCycle,
          }),
          ...(exportFilter?.planName?.length > 0 && {
            planNames: exportFilter?.planName,
          }),
          ...(exportFilter?.status?.length > 0 && {
            status: exportFilter?.status,
          }),
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.GIFT_CARD}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_LIBRARY,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() =>
              history?.push(`${ROUTES?.OFFERS}${ROUTES?.GIFT_CARD}/add`)
            }
          >
            Add New Gift Card
          </Button>
        )}
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_LIBRARY,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() =>
              history?.push(`${ROUTES?.OFFERS}${ROUTES?.GIFT_CARD}/add`)
            }
          >
            Add New Gift Card
          </Button>
        )}
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <Card className="full-height-without-nav">
        <GiftCardTable
          exportFilter={exportFilter}
          setExportFilter={setExportFilter}
        />
      </Card>
    </>
  );
};

export default GiftCard;
